import { render, staticRenderFns } from "./OrderFrom.vue?vue&type=template&id=5848596a&scoped=true&"
import script from "./OrderFrom.vue?vue&type=script&lang=js&"
export * from "./OrderFrom.vue?vue&type=script&lang=js&"
import style0 from "./OrderFrom.vue?vue&type=style&index=0&id=5848596a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848596a",
  null
  
)

export default component.exports